<p>simcard-status works!</p>
